module.exports = __webpack_public_path__ + "img/img14.34a2429c.svg";